import Icon from '@components/Icon';
import { flexStyle, textStyle } from '@themes/mixins';
import styled from 'styled-components';

export const Root = styled.div`
  ${flexStyle({ direction: 'column' })}
  gap: 16px;
  padding: 8px 0;
`;

export const FieldsRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
`;

export const ActionsRow = styled.div`
  ${flexStyle({ justify: 'flex-end' })}
  padding-top: 8px;
  border-top: 1px solid ${({ theme }) => theme.colors.divider};
`;

export const SuccessContainer = styled.div`
  ${flexStyle({ direction: 'column', align: 'center' })}
  gap: 12px;
  padding: 24px 0;
`;

export const SuccessIcon = styled(Icon)`
  color: ${({ theme }) => theme.colors.green};
`;

export const SuccessTitle = styled.div`
  ${textStyle({ weight: 600, size: '16px', color: 'textPrimary' })}
`;

export const SuccessDescription = styled.div`
  ${textStyle({ weight: 400, size: '13px', color: 'textSecondary' })}
`;

export const ErrorText = styled.div`
  ${textStyle({ weight: 400, size: '13px', color: 'danger' })}
`;

export const Hint = styled.div`
  ${textStyle({ weight: 400, size: '12px', color: 'textSecondary' })}
  padding: 4px 0;
`;
